import Backdrop from "@/components/base/backdrop";
import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import Products from "@/components/products/table";
import useQueryProducts from "@/hooks/queries/useQueryProducts";
import React from "react";

const ProductsPage: React.FC = () => {
  const { data: products, isFetching } = useQueryProducts();

  if (!products) {
    return <Backdrop loading={isFetching} />;
  }

  return (
    <PageLayout title="Products">
      <Products data={products} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "ProductsPage" })(ProductsPage);
